import React, { ReactElement } from 'react';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import { Icon } from '../../../Icon';
import styles from './index.module.css';

type DragHandleProps = Partial<DraggableProvidedDragHandleProps>;

export function DragHandle(props: DragHandleProps): ReactElement {
  return (
    <div {...props} className={styles.root}>
      <Icon name="list-menu" />
    </div>
  );
}
